import adobe from 'assets/logos/adobe.svg';
import angular from 'assets/logos/angular.svg';
import browserify from 'assets/logos/browserify.svg';
import chrome from 'assets/logos/chrome.svg';
import css from 'assets/logos/css.svg';
import fire from 'assets/logos/fire.svg';
import git from 'assets/logos/git.svg';
import html from 'assets/logos/html.svg';
import node from 'assets/logos/node.svg';
import rails from 'assets/logos/rails.svg';
import react from 'assets/logos/react.svg';
import redux from 'assets/logos/redux.svg';
import ruby from 'assets/logos/ruby.svg';
import saga from 'assets/logos/saga.svg';
import sass from 'assets/logos/sass.svg';
import webpack from 'assets/logos/webpack.svg';
import wordpress from 'assets/logos/wordpress.svg';

export default {
  adobe,
  angular,
  browserify,
  chrome,
  css,
  fire,
  git,
  html,
  node,
  rails,
  react,
  redux,
  ruby,
  saga,
  sass,
  webpack,
  wordpress,
};



// WEBPACK FOOTER //
// ./src/data/icons.js